import { render, staticRenderFns } from "./UiTable.vue?vue&type=template&id=21d76a1b&"
import script from "./UiTable.vue?vue&type=script&lang=js&"
export * from "./UiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports